import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class NoAuthenticationGuard {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate() {
    if (!this.authService.isLogged) {
      return true;
    }

    this.router.navigateByUrl('/');
    return false;
  }
}
